import React, { useMemo } from 'react';

import { useKeycloak } from '@react-keycloak/web';

import RedirectToKeycloak from './RedireactToKeycloak';
import BarLoader from '../components/Loader/barLoader';
import {
  getKeyCloakRealmFromLS,
  getLocalStorage,
} from '../hooks/authentication';

interface IProps {
  handleKeycloakRealmNameChange: (realmName: string) => void;
  children: React.ReactNode;
}

const PrivateRoute: React.FC<IProps> = ({
  handleKeycloakRealmNameChange,
  children,
}) => {
  const { keycloak } = useKeycloak();
  const keycloakRealmName = getKeyCloakRealmFromLS();
  const isLoggedIn = keycloak.authenticated;
  const handleKeycloakRedirection = () => {
    if (keycloak && !isLoggedIn) {
      keycloak.login();
    }
  };

  const accessToken = useMemo(() => getLocalStorage('accessToken'), []);

  if (isLoggedIn === true && accessToken !== undefined) {
    return <div>{children}</div>;
  } else if (isLoggedIn === false) {
    return (
      <RedirectToKeycloak
        keycloakRealmName={keycloakRealmName}
        handleKeycloakRedirection={handleKeycloakRedirection}
        handleKeycloakRealmNameChange={handleKeycloakRealmNameChange}
      />
    );
  } else {
    setTimeout(() => {}, 1000);

    return <BarLoader />;
  }
};

export default PrivateRoute;
